import AddRounded from '@mui/icons-material/AddRounded';
import Button from '@mui/material/Button';
import { useState } from 'react';

import { useSnackbar } from '@/contexts/SnackbarContext';

import AddLicenceDialog from './add-licence-dialog';

export interface AddLicenceButtonProps {
  /** Fired with the new licence id after a create; e.g. to refresh the list. */
  onCreated?: (id: string) => void;
}

/**
 * The list's "Add Licence" affordance: a soft primary button that opens the
 * single-field create form in a dialog, instead of routing to a whole page for
 * one field. The success snackbar lives here (one place), then `onCreated` lets
 * the host refresh in place.
 */
export default function AddLicenceButton({ onCreated }: AddLicenceButtonProps) {
  const [open, setOpen] = useState(false);
  const { notifySuccess } = useSnackbar();

  const handleCreated = (id: string) => {
    notifySuccess('Licence created successfully.');
    onCreated?.(id);
  };

  return (
    <>
      <Button
        variant="soft"
        color="primary"
        startIcon={<AddRounded />}
        onClick={() => setOpen(true)}
      >
        New licence
      </Button>
      <AddLicenceDialog open={open} onClose={() => setOpen(false)} onCreated={handleCreated} />
    </>
  );
}
